<template>
  <section class="h-full bg-purple-600 bg-gradient-to-r from-purple-600 via-purple-500 to-purple-600 rounded-xl shadow-xl">
  <div class="flex flex-col justify-between space-y-2 h-full relative">
    <nav v-if="chatRoom">
      <section  class="flex justify-between space-x-2 shadow-xl p-4">
        <div class="flex space-x-2 w-11/12">

          <div @click="$emit('setCurrentChatRoom',null)" class="pop-click text-2xl text-white my-auto md:hidden">
            <ion-icon name="arrow-back-outline"></ion-icon>
          </div>

          <div class="flex space-x-2 hover:bg-purple-500 px-2 py-0.5 rounded-md transition-colors pop-click" @click="$emit('setChatRoomInfo',chatRoom,chatRoom.id,true)">
            <div class="flex-shrink-0 my-auto w-8 md:w-10 h-8 md:h-10 rounded-full overflow-hidden shadow-xl relative">
              <img class="relative left-2/4 top-2/4  m-auto min-h-full min-w-full transform -translate-x-1/2 -translate-y-1/2 select-none object-cover" :src="chatRoom.icon" :alt="chatRoom.name" @error="$emit('errorIcon',key)">
            </div>
            <h6 class="text-white text-sm table my-auto line-clamp-2 ml-2">
              {{chatRoom.name}}
            </h6>
          </div>
        </div>
        
        <div v-click-outside="()=>toggleChatMenu(false)" @click="toggleChatMenu()" class="w-1/12 my-auto cursor-pointer transform hover:scale-105 active:scale-100 text-xl text-white flex justify-center">
          <ion-icon name="ellipsis-horizontal"></ion-icon>
        </div>
        <chat-menu-tab ref="chatMenuTab" :chatRoom="chatRoom" :currentUsersData="currentUsersData" @leaveChatRoom="$emit('leaveChatRoom',chatRoom.id)" @setChatRoomInfo="$emit('setChatRoomInfo',chatRoom,chatRoom.id,true)" ></chat-menu-tab>
      </section>
      <section class="w-full h-1 relative overflow-hidden"  v-if="isAddingMessages && !isMaxMessagesReached">
        <div class="bg-white w-1/4 rounded-full h-1 my-auto opacity-75 absolute line-loader-animation"></div>
      </section>
    </nav>
   
    <!-- chat box -->
    <section ref="mainContainer" class="overflow-auto white-small-scroll px-5 py-2 h-full" @click.capture="setMoreInfoMessage(' ')">

      
      <div  ref="scrollContainer">
        <chat-info-banner v-if="isMaxMessagesReached" :chatMembers="chatMembers" :chatRoom="chatRoom" ></chat-info-banner>

        <transition-group tag="div" name="slide-ups n" class="mt-auto flex flex-col-reverse">  
          <div v-for="chat in sortedChatMessages" :key="chat.id" :id="chat.id">

          <section v-if="!chat.isFromSystem">
              <div v-if="chat.senderId === currentUsersData.uid" class="flex justify-end my-1 space-x-2 transition-all">

                <!-- more info -->
                <transition name="fade">
                <div @click="setMoreInfoMessage(' ')" v-if="moreInfoMessageId === chat.id" class="max-h-full max-w-full text-white text-xs table my-auto">
                  <h6 class="inline break-all mr-2"> {{ getSender(chat.senderId, 'username') }} </h6>
                  <h6 class="inline"> {{ chat.dateGapFromNow }}</h6>
                </div>
                </transition>

                <div class="flex-shrink-0" style="max-width: 80%;">
                    <div @click="setMoreInfoMessage(chat.id)" class="text-purple-700 shadow-md text-sm bg-gray-50 hover:bg-gray-100 rounded-xl h-max pop-click py-2 pr-2 pl-3 " >
                      <h6 class="break-words select-text" v-html="urlify(chat.message)"></h6>
                    </div>
                </div>

              </div>

              <div v-else class="flex justify-start my-2 space-x-2 transition-all">
                <div @click="$emit('toggleUserInfoTab',true,getSender(chat.senderId),{})" class="flex-shrink-0 my-auto w-7 h-7 rounded-full  overflow-hidden pop-click  relative"  >
                  {{getSender(chat.senderId,'icon')}}
                  <img class="min-w-full min-h-full absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 cursor-pointer transition-all select-none z-10" :src="getSender(chat.senderId,'icon')" alt="User Icon" @error="$emit('setMemberIconToBlank',chat.senderId)" >

                </div>

                <div class="flex-shrink-0" style="max-width: 80%;">
                    <div @click="setMoreInfoMessage(chat.id)" class="text-white shadow-md text-sm  rounded-xl py-2 pr-3 pl-2  h-max pop-click border border-purple-300" >
                      <h6 class="break-words" v-html="urlify(chat.message)"></h6>
                    </div>
                </div>

                <!-- more info -->
                <transition name="fade">
                  <div @click="setMoreInfoMessage(' ')" v-if="moreInfoMessageId === chat.id" class="max-h-full max-w-full text-white text-xs table my-auto">
                    <h6 class="inline mr-2"> {{ chat.dateGapFromNow }}</h6>
                    <h6 class="inline break-all"> {{ getSender(chat.senderId,'username') }} </h6>
                  </div>
                </transition>

              </div>
          </section>
          <section v-else class="my-5">
            <div class="bg-pink-500 bg-gradient-to-t from-pink-400 to-pink-500 text-white p-2 rounded-md w-max mx-auto flex flex-col text-center">
              <span class="text-sm">
                {{chat.message}}
              </span>
              <span class="text-xs">
                {{new Date(chat.date).toLocaleDateString("en-US",{ year: 'numeric', month: 'long', day: 'numeric' })}}
              </span>
            </div>
          </section>

          </div>
          
        </transition-group>
      </div>

    </section>
    <transition name="fade">
      <div v-if="!isChatContainerOnBottom" class="absolute bottom-16 left-1/2 transform -translate-x-1/2 pop-click hover:scale-110 opacity-80">
        <div @click="chatScrollToBottom(false,true)" class="text-2xl flex justify-center">
          <ion-icon class="text-purple-600 bg-white p-1 rounded-full drop-shadow-2xl pop-click border border-purple-300" name="arrow-down"></ion-icon>
        </div>
      </div>
    </transition>

    <div class="flex space-x-1 pb-5 px-3">
      <div class="w-full flex relative">
          <div v-if="isSendingMessage" class="absolute right-2 top-2" title="Sending">
            <ion-icon class="animate-bounce text-2xl text-purple-600"  name="cloud-upload"></ion-icon>
          </div>
          <input @keyup.enter="sendMessage()" v-model="message" type="text" class="bg-white text-purple-600 rounded-lg bg-opacity-90 p-2 border-0 focus:outline-none w-full text-sm table my-auto" placeholder="Aa" id="sendMessageInput" autocomplete="off" autofocus/>
      </div>
      <div @click="sendMessage()" class="text-white text-3xl flex-shrink-0 pop-click flex select-none">
        <ion-icon class="table my-auto" name="send"></ion-icon>
      </div>
    </div>

  </div>  
  </section>
</template>

<script>
import firebase from "firebase/app";
import ChatInfoBanner from "@/components/ChatInfoBanner.vue";
import ChatMenuTab from "@/components/ChatMenuTab.vue";

export default {
  data(){
    return {
      isWaitingToScroll : false,
      currentLastMessageIndex : 0,
      isInfiniteScrollActivated : false,
      isAddingMessages : false,
      isChatContainerOnBottom : false,
      message : null,
      moreInfoMessageId : "",
      isSendingMessage : false,
      savedInputMessage : {} //save input message here so the message will retain even user navigate to different chat room
    }
  },
  components : {
    'chat-info-banner' : ChatInfoBanner,
    'chat-menu-tab' : ChatMenuTab
  },
  emits: ['errorIcon','setMemberIconToBlank','setCurrentChatRoom','leaveChatRoom','toggleUserInfoTab','setChatRoomInfo','topScrolled'],
  props : {
    blankIcon : String,
    currentUsersData : Object,
    chatRoom : Object,
    chatMessages : Object,
    chatMembers : Object,
    costumizedUsersData : Object,
    mainChatRoomLimit : Number,
    mainChatRoomAddPerLoad : Number
  },
  mounted(){
    this.chatScrollToBottom()
  },
  beforeUnmount () {
    if(this.isInfiniteScrollActivated)this.$refs.mainContainer.removeEventListener('scroll', this.checkChatContainerOnBottom);
  },
  methods : {
    urlify(text) {
      var urlRegex=new RegExp('^(https?:\\/\\/)'+ // protocol
      '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|'+ // domain name
      '((\\d{1,3}\\.){3}\\d{1,3}))'+ // OR ip (v4) address
      '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*'+ // port and path
      '(\\?[;&a-z\\d%_.~+=-]*)?'+ // query string
      '(\\#[-a-z\\d_]*)?$','i'); // fragment locator
      return text.replace(urlRegex, (url)=> {
        return '<a class="text-blue-500 hover:underline" href="' + url + '" target="_blank">' + url + '</a>';
      })
    },
    toggleChatMenu(toOpen = null){
      this.$refs.chatMenuTab.togglePopupTab(toOpen);
    },
    setMoreInfoMessage(chatId){
      this.moreInfoMessageId = chatId;
    },
    chatScrollToBottom(willAddScrollistener = false,isSmooth = false){
      if(this.isAddingMessages)return this.isWaitingToScroll = true;
      let chatContainer = this.$refs.mainContainer;
      let scrollBehavior =  'instant';
      if(isSmooth)scrollBehavior  = 'smooth';
      setTimeout(()=> {
        chatContainer.scrollTo({
          top : chatContainer.scrollHeight,
          behavior : scrollBehavior
          });
        this.isWaitingToScroll = false;
        if(willAddScrollistener){
          this.$refs.mainContainer.addEventListener('scroll', this.checkChatContainerOnBottom);
          this.isInfiniteScrollActivated = true;
        }
      } , 10)
    },
    checkChatContainerOnBottom () {
      let mainContainer = this.$refs.mainContainer;
      let scrollContainer = this.$refs.scrollContainer;
      let almostBottomOfContainer = (mainContainer.offsetHeight + mainContainer.scrollTop) >= (scrollContainer.offsetHeight) - 50;
      let onTopOfContainer = mainContainer.scrollTop === 0;  
      // console.log(almostBottomOfContainer,(mainContainer.offsetHeight + mainContainer.scrollTop),scrollContainer.offsetHeight);
      this.isChatContainerOnBottom = almostBottomOfContainer;
      if(onTopOfContainer && !this.isAddingMessages){
        // console.log('top');
        this.isAddingMessages = true;
        this.$emit('topScrolled');
      }
    },
    updateChatRoomRecentMessage(message){
      firebase.database().ref('chatRooms/' + this.chatRoom.id + '/recent').set({
        date : Date.now(),
        message : message,
        sender : {
          id : this.currentUsersData.uid,
          username : this.costumizedUsersData.username
        }
      });
    },
    sendMessage(){
      if(!this.message)return;
      if(this.isSendingMessage)return;
      const sendDate = Date.now();
      const newMessage = {
        date : sendDate,
        message : this.message,
        senderId : this.currentUsersData.uid,
        isFromSystem : false
      };
      this.isSendingMessage = true;
      const newPostKey = firebase.database().ref().child('chatMessages').push().key;
      firebase.database().ref('chatMessages/' + newPostKey).set(newMessage, (error) => {
        if (error) {
          console.error(error);
        } else {
          firebase.database().ref('/chatRooms/' + this.chatRoom.id + '/messagesIds/' + newPostKey).set(sendDate);
          this.updateChatRoomRecentMessage(newMessage.message);
          this.message = null;
          document.getElementById("sendMessageInput").focus();
          for(let id in this.chatMembers){
            firebase.database().ref('users/' +  id + '/chatRoomsId/' + this.chatRoom.id).set(sendDate);
          }
          this.isSendingMessage = false;
        }
      });
    },
    getSender(senderId, senderAttr = null){
      if(!this.chatMembers)return null;
      if(!this.chatMembers[senderId]){
        if(senderAttr === 'icon')return this.blankIcon;
        return null;
      }

      if(senderAttr === 'username' && this.chatMembers[senderId][senderAttr] === this.costumizedUsersData.username ) return 'You';
      if(!senderAttr)return this.chatMembers[senderId];
      return this.chatMembers[senderId][senderAttr];
    },
  },
  computed : {
    isMaxMessagesReached(){
      return this.messageCount === this.chatRoom.maxChatMessages;
    },
    sortedChatMessages(){
      if(!this.chatMessages)return {};
      return Object.entries(this.chatMessages)
      .sort(([,a],[,b]) => b.date-a.date)
      .reduce((r, [k, v]) => ({ ...r, [k]: v }), {});
    },
    messageCount(){
      if(!this.chatMessages)return 1;
      return Object.keys(this.chatMessages).length;
    },
    chatId(){
      return this.chatRoom.id;
    },
  },
  watch : {
    isAddingMessages(isAdding){
      if(!isAdding && this.isWaitingToScroll)this.chatScrollToBottom();
    },
    mainChatRoomLimit(limit){
      // console.log(limit, oldLimit);
      this.currentLastMessageIndex = limit - (this.mainChatRoomAddPerLoad * 2);
    },
    messageCount(newCount){
      if(this.isMaxMessagesReached)newCount = this.mainChatRoomLimit;
      if(newCount >= this.mainChatRoomLimit){
        if(!this.isInfiniteScrollActivated){
          this.chatScrollToBottom(true);
        }
        this.isAddingMessages = false;
      }
      if(this.isAddingMessages){
        const currentLastMessageId = Object.keys(this.chatMessages)[this.currentLastMessageIndex];
        const lastMessageElement = document.getElementById(currentLastMessageId);
        if(currentLastMessageId && lastMessageElement){
          lastMessageElement.scrollIntoView();
        }
      }else{
        let mainContainer = this.$refs.mainContainer;
        let scrollContainer = this.$refs.scrollContainer;
        let almostBottomOfContainer = (mainContainer.offsetHeight + mainContainer.scrollTop) >= (scrollContainer.offsetHeight) - 50;
        if(almostBottomOfContainer)this.chatScrollToBottom();
      }
     
    },
    chatId(chatId,prevChatId){
      if(this.message)this.savedInputMessage[prevChatId] = this.message;
      this.message = "";
      if(this.savedInputMessage[chatId] !== null)this.message = this.savedInputMessage[chatId];
      this.isInfiniteScrollActivated = false;
    }
  }
}
</script>

<style>
  .decrement-width {
    animation-name: decrementWidth;
    transition: all linear;
    animation-duration: 10s;
  }
  .pause-animation {
    animation-play-state: paused;
  }
  @keyframes decrementWidth{
    from {width: 100%;}
    to {width: 0px;}
  }

  .line-loader-animation {
    animation-name: line-loader;
    transition: all linear;
    animation-duration: 2s;
    animation-iteration-count: infinite;
  }
  @keyframes line-loader{
    0%   {left: -10%;width: 10%}
    50%  {width: 50%}
    100% {left: 100%;width: 10%}
  }
</style>